import { TextField as BaseTextField } from "@mui/material";
import { styled } from "@mui/material/styles";

const TextField = styled(BaseTextField)({
  "& label.Mui-focused": {
    color: "#A0AAB4",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#B2BAC2",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#E0E3E7",
    },
    "&:hover fieldset": {
      borderColor: "#B2BAC2",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#6F7E8C",
    },
  },
});

export default function CustomTextField(TextFieldProps) {
  return (
    <TextField {...TextFieldProps} fullWidth size="small" margin="dense" />
  );
}
